"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var evalCode = '(() => function*(){})().constructor';
try {
    exports.generatorFunctionConstructor = eval(evalCode);
}
catch (e) {
    // ignore
}
